

export const formatLanguageCodeForHrefLang = (
  languageCode: string
): LanguageCode => {
  return languageCode.replace('_', '-') as LanguageCode;
};
export const getLangMetas = ({
  defaultLocale,
  pageData,
  siteUrl,
}: {
  defaultLocale: string;
  pageData: { translations: Queries.PageDAccueilQuery['wpPage']['translations'], link: Queries.PageDAccueilQuery['wpPage']['link'], language: Queries.PageDAccueilQuery['wpPage']['language'] };
  siteUrl: string | undefined;
}) => {
  if (pageData.translations.length === 0) return null;
  const currentPage = {
    href: `${siteUrl}${pageData.link}`,
    hrefLang: formatLanguageCodeForHrefLang(pageData.language?.locale),
    rel: 'alternate',
  };
  const otherPages = pageData.translations.map((translation) => ({
    href: `${siteUrl}${translation.uri}`,
    hrefLang: formatLanguageCodeForHrefLang(translation.language?.locale),
    rel: 'alternate',
  }));
  const defaultLangMeta = {
    href: [currentPage, ...otherPages].find(
      (langMeta) =>
        langMeta.hrefLang === formatLanguageCodeForHrefLang(defaultLocale)
    )?.href,
    hrefLang: 'x-default',
    rel: 'alternate',
  };
  return [currentPage, defaultLangMeta, ...otherPages];
};
